import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompetencyLevel, Aspect } from '../../models/evaluation.model';
import { StatusIconComponent } from '../status-icons/status-icon.component';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
	selector: 'app-competency-button',
	standalone: true,
	imports: [CommonModule, StatusIconComponent, MatIconModule],
	templateUrl: './competency-button.component.html',
	styleUrls: ['./competency-button.component.scss'],
})
export class CompetencyButtonComponent {
	@Input() label!: string;
	@Input() value!: CompetencyLevel;
	@Input() aspect!: Aspect;
	@Output() buttonToggle = new EventEmitter<CompetencyLevel>();

	constructor(private sanitizer: DomSanitizer) {}

	handleClick() {
		this.buttonToggle.emit(this.value);
	}

	get buttonVariantClass() {
		return this.value.toLowerCase().replaceAll(' ', '-');
	}

	get selected() {
		return this.aspect.competencyLevel === this.value;
	}

	get aiSuggested() {
		return (
			// AI Suggested label should only appear if the suitability level is FULL
			this.aspect.suitability === 'FULL' &&
			this.aspect.aiSuggestedCompetencyLevel === this.value
		);
	}

	get description() {
		const index = this.aspect.competencyDescriptions?.findIndex(
			x => x.competencyLevel === this.value,
		);
		if (index !== undefined && index !== -1) {
			// We are assuming that the html tags returned in the competencyDescription is
			// always safe.
			return this.sanitizer.bypassSecurityTrustHtml(
				this.aspect.competencyDescriptions![index].description,
			);
		}
		return;
	}
}
